// CRYPTOBOOM Landing v2 — multi-language dictionary
// Supported locales: es (default), en, ru, pt-BR

export const SUPPORTED_LOCALES = [
  { code: "es", label: "ES", flag: "🇪🇸" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "ru", label: "RU", flag: "🇷🇺" },
  { code: "pt-br", label: "BR", flag: "🇧🇷" },
];

export const DEFAULT_LOCALE = "es";

export function detectLocale() {
  if (typeof navigator === "undefined") return DEFAULT_LOCALE;
  const saved = typeof localStorage !== "undefined" ? localStorage.getItem("cb_locale") : null;
  if (saved && SUPPORTED_LOCALES.some((l) => l.code === saved)) return saved;
  const raw = (navigator.language || "es").toLowerCase();
  if (raw.startsWith("pt")) return "pt-br";
  if (raw.startsWith("ru")) return "ru";
  if (raw.startsWith("en")) return "en";
  return "es";
}

export const TRANSLATIONS = {
  es: {
    meta_title: "CRYPTOBOOM — Play. Earn. Explode the Blockchain.",
    ticker: [
      "🎮 CRYPTOBOOM ESTÁ EN VIVO",
      "💰 GANA TOKENS UNI2 REALES",
      "🚀 OBJETIVO: 1,000,000 USUARIOS EN 90 DÍAS",
      "🎓 APRENDE CRYPTO MIENTRAS JUEGAS",
      "🔥 500 BC = 1 TOKEN UNI2 (EARLY ADOPTER)",
      "🏆 RECOMPENSAS SEMANALES DEL LEADERBOARD",
    ],
    fc_label: "💥 BOOM Credits ganados",
    fc_sub: "por la comunidad hoy",
    ref_banner: {
      text_1: "🎁 Vienes invitado por ",
      text_2: " — recibes un bonus de ",
      bonus: "+100 BC",
      text_3: " al registrarte",
      close: "Cerrar",
    },
    nav: {
      play: "Jugar",
      earn: "Ganar",
      tasks: "Misiones",
      rank: "Ranking",
      academy: "Academia",
      nfts: "NFTs",
      cta: "JUGAR YA",
    },
    hero: {
      eyebrow: "💣 ECOSISTEMA UNI2CHAIN · WEB3 GAMING",
      title_line1_a: "CRYPTO",
      title_line1_b: "BOOM",
      title_line2: "PLAY. EARN. ",
      title_line2_accent: "EXPLODE.",
      sub_1: "El juego casual más ",
      sub_strong_1: "viral del blockchain",
      sub_2: ". Vuela, destruye bloques cripto, comparte tu score y convierte tus ",
      sub_strong_2: "BOOM Credits en tokens UNI2 reales",
      sub_3: ".",
      cta_primary: "💣 JUGAR GRATIS",
      cta_secondary: "VER RECOMPENSAS →",
    },
    stats: [
      { num: "1,000,000", label: "Target de usuarios" },
      { num: "5,000,000 UNI2", label: "Tokens a distribuir" },
      { num: "500 BC", label: "BC por 1 Token (early)" },
      { num: "50%", label: "Retention D7 target" },
      { num: "90 días", label: "Para 1M de usuarios" },
    ],
    howto: {
      label: "🎮 Mecánicas del Juego",
      title_1: "Tap, vuela, destruye.",
      title_accent: "Pero con crypto.",
      sub: "Mecánicas simples que enganchan en segundos. Profundidad que te mantiene horas.",
      steps: [
        { icon: "✋", title: "Tap para Volar", desc: "Toca la pantalla para que CRYPTOBOOM ascienda. Suelta y cae. Mantén el ritmo perfecto para sobrevivir." },
        { icon: "💥", title: "Swipe para Destruir", desc: "Desliza horizontalmente para lanzar un ataque. Los bloques cripto destructibles explotan dándote puntos extra." },
        { icon: "🪙", title: "Recoge Coins", desc: "Los coins flotantes en el camino suman +5 BC cada uno. Calcular las rutas óptimas es la habilidad secreta." },
        { icon: "📊", title: "Score = Créditos", desc: "Tu puntuación final se convierte en BOOM Credits. Cuanto más lejos llegues, más ganas. Sin límite diario." },
        { icon: "📤", title: "Comparte tu Score", desc: "Cada vez que compartes tu resultado en redes obtienes +50 BC extra. Screenshot automático incluido." },
        { icon: "💎", title: "Canjea por Tokens", desc: "Acumula BOOM Credits y conviértelos en UNI2 Tokens reales directamente en tu wallet blockchain." },
      ],
    },
    earn: {
      label: "💰 Sistema de Recompensas",
      title_1: "Cada acción vale ",
      title_accent: "dinero real.",
      sub: "No son puntos vacíos. Los BOOM Credits son convertibles a tokens UNI2 reales en blockchain.",
      items: [
        { icon: "🎮", name: "Jugar una partida", detail: "Basado en score final · sin límite diario", reward: "+10–100 BC" },
        { icon: "📤", name: "Compartir resultado", detail: "Screenshot automático · hasta 3 veces/día", reward: "+50 BC" },
        { icon: "🎬", name: "Ver video educativo", detail: "YouTube embed diario · 2-3 minutos", reward: "+25 BC" },
        { icon: "🧠", name: "Quiz post-video", detail: "1-2 preguntas · sin penalización si fallas", reward: "+5–15 BC" },
        { icon: "👥", name: "Referir amigos", detail: "+100 BC por cada 3 descargas · sin límite", reward: "+100 BC" },
        { icon: "📚", name: "Completar módulo", detail: "Academia Web3 · certificado digital incluido", reward: "+50 BC" },
        { icon: "🏆", name: "Top 10 leaderboard", detail: "Ranking semanal · Oro/Plata/Bronce", reward: "+250–1000 BC", orange: true },
      ],
      conv_title: "💱 CONVERSIÓN BC → UNI2",
      conv_rows: [
        { label: "Tasa Early Adopter (30 días)", val: "500 BC = 1 UNI2" },
        { label: "Tasa Estándar", val: "1000 BC = 1 UNI2" },
        { label: "Tasa Tardía (6+ meses)", val: "1500 BC = 1 UNI2" },
        { label: "Staking 30 días", val: "+20% BC bonus" },
        { label: "Staking 90 días", val: "+35% BC bonus" },
        { label: "Staking 180 días", val: "+50% BC bonus" },
      ],
      bonus_strong: "⚡ Early Adopter Advantage:",
      bonus_text: " Los primeros 30 días la tasa es ",
      bonus_highlight: "un 50% mejor",
      bonus_tail: ". Cuanto antes empieces, más tokens por el mismo esfuerzo. El tiempo importa en blockchain.",
    },
    tasks: {
      label: "📱 Misiones Sociales",
      title_1: "Síguenos. Únete. ",
      title_accent: "Cobra.",
      sub: "Completar tareas sociales da créditos reales. Una vez, para siempre. El ecosistema crece, tú ganas.",
      cards: [
        { col: "tg", icon: "✈️", name: "Únete al Telegram", desc: "El canal oficial de UNI2Chain. Noticias, alertas, alpha exclusivo y comunidad 24/7.", badge: "+100 BC", freq: "Una vez · permanente" },
        { col: "ig", icon: "📸", name: "Seguir en Instagram", desc: "Contenido exclusivo, tips del juego, drops de NFTs y anuncios de eventos.", badge: "+75 BC", freq: "Una vez · permanente" },
        { col: "yt", icon: "▶️", name: "Suscribir a YouTube", desc: "Tutoriales crypto, gameplay walkthroughs y cursos Web3 gratuitos en video.", badge: "+60 BC", freq: "Una vez · permanente" },
        { col: "tw", icon: "🐦", name: "Seguir en X / Twitter", desc: "Updates en tiempo real, polls de la comunidad y retweets que te dan BC extra.", badge: "+50 BC", freq: "Una vez · permanente" },
        { col: "share", icon: "🔗", name: "Compartir resultado", desc: "Cada partida genera un screenshot épico. Compártelo y reta a tus amigos a superarte.", badge: "+50 BC", freq: "Hasta 3x por día · ilimitado" },
        { col: "ref", icon: "🤝", name: "Referral de amigos", desc: "Tu código único trae amigos. Ellos ganan bonus al entrar, tú ganas por siempre que jueguen.", badge: "+100 BC / 3 amigos", freq: "Ilimitado · también ganas 10 BC por cada partida de tu red", orange: true },
      ],
    },
    gami: {
      label: "🎯 Gamificación Profunda",
      title_1: "El juego que no ",
      title_accent: "puedes dejar.",
      sub: "Cada mecánica está diseñada para crear hábito, competencia y deseo de volver cada día.",
      cards: [
        { icon: "🔥", title: "Daily Streaks", desc: "Juega días consecutivos y multiplica tus ganancias. Perder el streak duele — y eso te hace volver.", highlight: "+10% BC POR DÍA CONSECUTIVO" },
        { icon: "🏆", title: "Leaderboard Global", desc: "Top 100 visible. Se actualiza cada hora. Los líderes ganan BC reales cada semana. ¿Estás en el top?", highlight: "HASTA 1,000 BC SEMANALES" },
        { icon: "⚡", title: "Battle Pass", desc: "50 niveles de recompensas en 30 días. Gratis te da acceso básico. Premium desbloquea cosmetics exclusivos y NFTs raros.", highlight: "$4.99 O 1,000 BC" },
        { icon: "🎪", title: "Eventos Limitados", desc: "Cada 2 semanas un evento especial de 48 horas. Temáticas únicas, cosmetics exclusivos y 2x BC multiplicados.", highlight: "CADA 2 SEMANAS · 48H" },
        { icon: "⚔️", title: "Desafíos PvP", desc: "Reta a amigos con tu código personal. Supera su mejor score. Si ganan sobre ti, ambos reciben recompensa extra.", highlight: "+30 BC POR VICTORIA" },
        { icon: "🎯", title: "Daily Challenge", desc: "Un objetivo especial cada día. \"Destruye 10 bloques BTC\" o \"llega a 500m\". Completarlo alimenta tu streak.", highlight: "+50 BC + MANTIENE STREAK" },
      ],
    },
    streaks: {
      label: "🔥 Sistema de Rachas",
      title_1: "Cada día importa. ",
      title_accent: "No rompas la racha.",
      steps: [
        { day: "DÍA 1", reward: "🎮", text: "Inicia tu racha. Los primeros créditos son tuyos." },
        { day: "DÍA 3", reward: "⚡", text: "Power-up gratis desbloqueado. Boost especial para tu próxima partida." },
        { day: "DÍA 7", reward: "🛍️", text: "20% de descuento en toda la tienda por 7 días completos." },
        { day: "DÍA 30", reward: "🎰", text: "Entrada a la Ruleta de Recompensas. Tokens, NFTs, skins legendarias." },
      ],
    },
    leaderboard: {
      label: "🏆 Leaderboard Global",
      title_1: "¿Estás en el ",
      title_accent: "TOP 100?",
      sub: "El ranking se actualiza cada hora. Los mejores cada semana reciben BOOM Credits reales.",
      h_rank: "#", h_player: "Jugador", h_score: "Score", h_bc: "BC Earned",
      rows: [
        { rank: "👑 1", cls: "rank-1", av: "CX", name: "CryptoXavier", country: "🇲🇽 México", score: "284,750", bc: "28,475 BC" },
        { rank: "🥈 2", cls: "rank-2", av: "LB", name: "LunaBoom", country: "🇨🇴 Colombia", score: "271,340", bc: "27,134 BC", avStyle: "linear-gradient(135deg,#f7931a,#ffcc00)" },
        { rank: "🥉 3", cls: "rank-3", av: "DM", name: "DefiMaster_ES", country: "🇪🇸 España", score: "258,910", bc: "25,891 BC", avStyle: "linear-gradient(135deg,#bb55ff,#5588ff)" },
        { rank: "4", cls: "rank-other", av: "BK", name: "BlockKing_AR", country: "🇦🇷 Argentina", score: "241,200", bc: "24,120 BC", avStyle: "linear-gradient(135deg,#00aaff,#00ffcc)" },
        { rank: "5", cls: "rank-other", av: "SH", name: "SatoshiHunter", country: "🇵🇪 Perú", score: "229,880", bc: "22,988 BC", avStyle: "linear-gradient(135deg,#ff5588,#ffaa00)" },
        { rank: "6", cls: "rank-other", av: "WM", name: "Web3Maniac_UAE", country: "🇦🇪 Dubai", score: "218,500", bc: "21,850 BC", avStyle: "linear-gradient(135deg,#33ff88,#00aaff)" },
        { rank: "7", cls: "rank-other", av: "NB", name: "NakamotoBomb", country: "🇧🇷 Brasil", score: "204,770", bc: "20,477 BC", avStyle: "linear-gradient(135deg,#ffdd00,#ff6600)" },
      ],
      cta_text: "Actualización cada hora · ",
      cta_link: "Juega ahora y aparece aquí →",
    },
    edu: {
      label: "🎓 Academia Web3",
      title_1: "Aprende crypto. ",
      title_accent: "Que te paguen.",
      sub: "Cada sesión comienza con un video educativo de 2-3 minutos. Aprende blockchain mientras ganas tokens.",
      modules: [
        { icon: "₿", name: "¿Qué es Bitcoin?", meta: "2 min · Nivel básico", bc: "+25 BC" },
        { icon: "⛓️", name: "Blockchain explicado", meta: "3 min · Nivel básico", bc: "+25 BC" },
        { icon: "🏦", name: "Introducción a DeFi", meta: "3 min · Nivel medio", bc: "+25 BC" },
        { icon: "🔐", name: "Seguridad en Crypto", meta: "2 min · Nivel básico", bc: "+25 BC" },
        { icon: "🌐", name: "UNI2Chain y Web3", meta: "3 min · Nivel medio", bc: "+50 BC" },
        { icon: "🎓", name: "Módulo Completo", meta: "5 lecciones · Certificado digital", bc: "+50 BC + NFT", orange: true },
      ],
      visual_title: "VIDEO DIARIO OBLIGATORIO",
      visual_text_1: "Antes de tu primera partida del día, ve un video educativo corto sobre blockchain y crypto. Es obligatorio — y te pagan por hacerlo.",
      visual_text_2: "Al terminar, un quiz rápido de 1-2 preguntas. Acertar da más BC. Fallar da BC igual. Sin penalización. Solo aprendizaje.",
      badge: "🏆 Certificado NFT al completar el módulo",
    },
    nft: {
      label: "💎 Cosmetics & NFTs",
      title_1: "Tu CRYPTOBOOM, ",
      title_accent: "tu identidad.",
      sub: "Skins coleccionables, rareza on-chain, tradeable en OpenSea. 100 NFTs nuevos cada mes.",
      cards: [
        { tier: "common", emoji: "💣", name: "CLASSIC BOOM", price: "200 BC", rarity: "COMMON" },
        { tier: "rare", emoji: "🔵", name: "CYBER BOOM", price: "500 BC", rarity: "RARE" },
        { tier: "epic", emoji: "⚡", name: "PLASMA BOOM", price: "1,000 BC", rarity: "EPIC" },
        { tier: "legendary", emoji: "👑", name: "SATOSHI BOOM", price: "10,000 BC", rarity: "LEGENDARY" },
      ],
      footnote: "Los NFTs son ERC-721 en UNI2Chain. Tradeables en OpenSea. 5% royalty al creador. 100 nuevos cada mes.",
    },
    viral: {
      l1: "Juegas. Ganas tokens reales.",
      l2: "Compartes. Tu red te paga.",
      l3: "Aprendes crypto sin darte cuenta.",
      l4: "Todo en 5 minutos al día.",
      stats: [
        { num: "1.45x", label: "Viral K-Factor", color: "green" },
        { num: "35%", label: "Share Rate Target", color: "orange" },
        { num: "50%", label: "Retention Day 7", color: "blue" },
        { num: "7 días", label: "Doubling Time", color: "green" },
      ],
      cta: "💥 ÚNETE AHORA · EARLY ADOPTER BONUS ACTIVO",
    },
    eco: {
      label: "🌐 Ecosistema UNI2Chain",
      title_1: "CRYPTOBOOM es ",
      title_accent: "la puerta de entrada.",
      sub: "El juego conecta con todo el ecosistema blockchain de UNI2. Cada usuario del juego es un potencial miembro activo.",
      nodes: [
        { icon: "🎮", name: "CRYPTOBOOM", desc: "Juego casual viral" },
        { icon: "🪙", name: "BOOM CREDITS", desc: "Moneda in-game" },
        { icon: "💎", name: "UNI2 TOKEN", desc: "Blockchain nativo" },
        { icon: "🏦", name: "STAKING", desc: "Earn APY + BC" },
        { icon: "🌐", name: "UNI2CHAIN", desc: "Ecosistema completo" },
      ],
    },
    cta: {
      title_1: "¿LISTO PARA",
      title_accent: "EXPLOTAR",
      title_2: "EL BLOCKCHAIN?",
      sub_1: "El early adopter bonus ",
      sub_strong: "expira pronto",
      sub_2: ". 500 BC = 1 UNI2 Token. Solo los primeros 30 días. Después sube a 1,000 BC. No esperes.",
      btn_primary: "💣 JUGAR AHORA — ES GRATIS",
      btn_app: "📱 APP STORE",
      btn_play: "🤖 GOOGLE PLAY",
      note_1: "100% gratuito · Sin compras obligatorias · ",
      note_link: "Leer tokenomía →",
    },
    footer: {
      tagline: "El juego viral de UNI2Chain que convierte jugadores casuales en ciudadanos del blockchain. Play. Earn. Explode.",
      col1: { title: "JUEGO", items: ["Cómo jugar", "Leaderboard", "Battle Pass", "Eventos"] },
      col2: { title: "EARN", items: ["BOOM Credits", "Convertir Tokens", "Staking", "Referral"] },
      col3: { title: "UNI2", items: ["UNI2Chain", "Tokenomía", "CBC Business Club", "Whitepaper"] },
      copyright: "© 2026 CRYPTOBOOM · UNI2Chain Ecosystem · CBC Business Club",
    },
  },

  en: {
    meta_title: "CRYPTOBOOM — Play. Earn. Explode the Blockchain.",
    ticker: [
      "🎮 CRYPTOBOOM IS LIVE",
      "💰 EARN REAL UNI2 TOKENS",
      "🚀 1,000,000 USERS TARGET IN 90 DAYS",
      "🎓 LEARN CRYPTO WHILE YOU PLAY",
      "🔥 500 BC = 1 UNI2 TOKEN (EARLY ADOPTER)",
      "🏆 WEEKLY LEADERBOARD REWARDS",
    ],
    fc_label: "💥 BOOM Credits earned",
    fc_sub: "by the community today",
    ref_banner: {
      text_1: "🎁 You're invited by ",
      text_2: " — get a ",
      bonus: "+100 BC",
      text_3: " welcome bonus when you sign up",
      close: "Close",
    },
    nav: { play: "Play", earn: "Earn", tasks: "Missions", rank: "Ranking", academy: "Academy", nfts: "NFTs", cta: "PLAY NOW" },
    hero: {
      eyebrow: "💣 UNI2CHAIN ECOSYSTEM · WEB3 GAMING",
      title_line1_a: "CRYPTO", title_line1_b: "BOOM",
      title_line2: "PLAY. EARN. ", title_line2_accent: "EXPLODE.",
      sub_1: "The most ", sub_strong_1: "viral casual game on blockchain",
      sub_2: ". Fly, destroy crypto blocks, share your score and convert your ",
      sub_strong_2: "BOOM Credits into real UNI2 tokens",
      sub_3: ".",
      cta_primary: "💣 PLAY FREE", cta_secondary: "SEE REWARDS →",
    },
    stats: [
      { num: "1,000,000", label: "User target" },
      { num: "5,000,000 UNI2", label: "Tokens to distribute" },
      { num: "500 BC", label: "BC per 1 Token (early)" },
      { num: "50%", label: "Retention D7 target" },
      { num: "90 days", label: "To reach 1M users" },
    ],
    howto: {
      label: "🎮 Game Mechanics",
      title_1: "Tap, fly, destroy.", title_accent: "But with crypto.",
      sub: "Simple mechanics that hook in seconds. Depth that keeps you playing for hours.",
      steps: [
        { icon: "✋", title: "Tap to Fly", desc: "Tap the screen to make CRYPTOBOOM ascend. Release and fall. Keep the perfect rhythm to survive." },
        { icon: "💥", title: "Swipe to Destroy", desc: "Swipe horizontally to launch an attack. Destructible crypto blocks explode giving you extra points." },
        { icon: "🪙", title: "Collect Coins", desc: "Floating coins on the path add +5 BC each. Calculating optimal routes is the secret skill." },
        { icon: "📊", title: "Score = Credits", desc: "Your final score converts to BOOM Credits. The further you go, the more you earn. No daily cap." },
        { icon: "📤", title: "Share Your Score", desc: "Every time you share your result on social media you get +50 BC extra. Auto screenshot included." },
        { icon: "💎", title: "Redeem for Tokens", desc: "Stack BOOM Credits and convert them into real UNI2 tokens directly in your blockchain wallet." },
      ],
    },
    earn: {
      label: "💰 Rewards System",
      title_1: "Every action is worth ", title_accent: "real money.",
      sub: "Not empty points. BOOM Credits are convertible into real UNI2 tokens on blockchain.",
      items: [
        { icon: "🎮", name: "Play a match", detail: "Based on final score · no daily cap", reward: "+10–100 BC" },
        { icon: "📤", name: "Share result", detail: "Auto screenshot · up to 3 times/day", reward: "+50 BC" },
        { icon: "🎬", name: "Watch educational video", detail: "Daily YouTube embed · 2-3 minutes", reward: "+25 BC" },
        { icon: "🧠", name: "Post-video quiz", detail: "1-2 questions · no penalty if you fail", reward: "+5–15 BC" },
        { icon: "👥", name: "Refer friends", detail: "+100 BC per 3 downloads · unlimited", reward: "+100 BC" },
        { icon: "📚", name: "Complete module", detail: "Web3 Academy · digital certificate included", reward: "+50 BC" },
        { icon: "🏆", name: "Top 10 leaderboard", detail: "Weekly ranking · Gold/Silver/Bronze", reward: "+250–1000 BC", orange: true },
      ],
      conv_title: "💱 CONVERSION BC → UNI2",
      conv_rows: [
        { label: "Early Adopter Rate (30 days)", val: "500 BC = 1 UNI2" },
        { label: "Standard Rate", val: "1000 BC = 1 UNI2" },
        { label: "Late Rate (6+ months)", val: "1500 BC = 1 UNI2" },
        { label: "Staking 30 days", val: "+20% BC bonus" },
        { label: "Staking 90 days", val: "+35% BC bonus" },
        { label: "Staking 180 days", val: "+50% BC bonus" },
      ],
      bonus_strong: "⚡ Early Adopter Advantage:",
      bonus_text: " The first 30 days the rate is ", bonus_highlight: "50% better",
      bonus_tail: ". The earlier you start, the more tokens for the same effort. Time matters in blockchain.",
    },
    tasks: {
      label: "📱 Social Missions",
      title_1: "Follow us. Join. ", title_accent: "Cash in.",
      sub: "Completing social tasks pays real credits. Once, forever. The ecosystem grows, you earn.",
      cards: [
        { col: "tg", icon: "✈️", name: "Join Telegram", desc: "The official UNI2Chain channel. News, alerts, exclusive alpha and 24/7 community.", badge: "+100 BC", freq: "Once · permanent" },
        { col: "ig", icon: "📸", name: "Follow on Instagram", desc: "Exclusive content, game tips, NFT drops and event announcements.", badge: "+75 BC", freq: "Once · permanent" },
        { col: "yt", icon: "▶️", name: "Subscribe on YouTube", desc: "Crypto tutorials, gameplay walkthroughs and free Web3 video courses.", badge: "+60 BC", freq: "Once · permanent" },
        { col: "tw", icon: "🐦", name: "Follow on X / Twitter", desc: "Real-time updates, community polls and retweets that give you extra BC.", badge: "+50 BC", freq: "Once · permanent" },
        { col: "share", icon: "🔗", name: "Share result", desc: "Every match generates an epic screenshot. Share it and challenge your friends to beat you.", badge: "+50 BC", freq: "Up to 3x per day · unlimited" },
        { col: "ref", icon: "🤝", name: "Friend Referral", desc: "Your unique code brings friends. They get bonus on entry, you earn forever while they play.", badge: "+100 BC / 3 friends", freq: "Unlimited · also earn 10 BC per match from your network", orange: true },
      ],
    },
    gami: {
      label: "🎯 Deep Gamification",
      title_1: "The game you ", title_accent: "can't quit.",
      sub: "Every mechanic is designed to create habit, competition and desire to return every day.",
      cards: [
        { icon: "🔥", title: "Daily Streaks", desc: "Play consecutive days and multiply your earnings. Losing the streak hurts — and that makes you come back.", highlight: "+10% BC PER CONSECUTIVE DAY" },
        { icon: "🏆", title: "Global Leaderboard", desc: "Top 100 visible. Updates every hour. Leaders earn real BC every week. Are you in the top?", highlight: "UP TO 1,000 BC WEEKLY" },
        { icon: "⚡", title: "Battle Pass", desc: "50 levels of rewards in 30 days. Free gives you basic access. Premium unlocks exclusive cosmetics and rare NFTs.", highlight: "$4.99 OR 1,000 BC" },
        { icon: "🎪", title: "Limited Events", desc: "Every 2 weeks a special 48-hour event. Unique themes, exclusive cosmetics and 2x BC multiplied.", highlight: "EVERY 2 WEEKS · 48H" },
        { icon: "⚔️", title: "PvP Challenges", desc: "Challenge friends with your personal code. Beat their best score. If they win, both get extra reward.", highlight: "+30 BC PER VICTORY" },
        { icon: "🎯", title: "Daily Challenge", desc: "A special goal every day. \"Destroy 10 BTC blocks\" or \"reach 500m\". Completing it feeds your streak.", highlight: "+50 BC + KEEPS STREAK" },
      ],
    },
    streaks: {
      label: "🔥 Streak System",
      title_1: "Every day matters. ", title_accent: "Don't break the streak.",
      steps: [
        { day: "DAY 1", reward: "🎮", text: "Start your streak. The first credits are yours." },
        { day: "DAY 3", reward: "⚡", text: "Free power-up unlocked. Special boost for your next match." },
        { day: "DAY 7", reward: "🛍️", text: "20% discount on the entire store for 7 complete days." },
        { day: "DAY 30", reward: "🎰", text: "Entry to the Rewards Wheel. Tokens, NFTs, legendary skins." },
      ],
    },
    leaderboard: {
      label: "🏆 Global Leaderboard",
      title_1: "Are you in the ", title_accent: "TOP 100?",
      sub: "Ranking updates every hour. The best each week receive real BOOM Credits.",
      h_rank: "#", h_player: "Player", h_score: "Score", h_bc: "BC Earned",
      rows: [
        { rank: "👑 1", cls: "rank-1", av: "CX", name: "CryptoXavier", country: "🇲🇽 Mexico", score: "284,750", bc: "28,475 BC" },
        { rank: "🥈 2", cls: "rank-2", av: "LB", name: "LunaBoom", country: "🇨🇴 Colombia", score: "271,340", bc: "27,134 BC", avStyle: "linear-gradient(135deg,#f7931a,#ffcc00)" },
        { rank: "🥉 3", cls: "rank-3", av: "DM", name: "DefiMaster_ES", country: "🇪🇸 Spain", score: "258,910", bc: "25,891 BC", avStyle: "linear-gradient(135deg,#bb55ff,#5588ff)" },
        { rank: "4", cls: "rank-other", av: "BK", name: "BlockKing_AR", country: "🇦🇷 Argentina", score: "241,200", bc: "24,120 BC", avStyle: "linear-gradient(135deg,#00aaff,#00ffcc)" },
        { rank: "5", cls: "rank-other", av: "SH", name: "SatoshiHunter", country: "🇵🇪 Peru", score: "229,880", bc: "22,988 BC", avStyle: "linear-gradient(135deg,#ff5588,#ffaa00)" },
        { rank: "6", cls: "rank-other", av: "WM", name: "Web3Maniac_UAE", country: "🇦🇪 Dubai", score: "218,500", bc: "21,850 BC", avStyle: "linear-gradient(135deg,#33ff88,#00aaff)" },
        { rank: "7", cls: "rank-other", av: "NB", name: "NakamotoBomb", country: "🇧🇷 Brazil", score: "204,770", bc: "20,477 BC", avStyle: "linear-gradient(135deg,#ffdd00,#ff6600)" },
      ],
      cta_text: "Updates every hour · ", cta_link: "Play now and show up here →",
    },
    edu: {
      label: "🎓 Web3 Academy",
      title_1: "Learn crypto. ", title_accent: "Get paid for it.",
      sub: "Every session starts with a 2-3 minute educational video. Learn blockchain while you earn tokens.",
      modules: [
        { icon: "₿", name: "What is Bitcoin?", meta: "2 min · Basic level", bc: "+25 BC" },
        { icon: "⛓️", name: "Blockchain explained", meta: "3 min · Basic level", bc: "+25 BC" },
        { icon: "🏦", name: "Intro to DeFi", meta: "3 min · Medium level", bc: "+25 BC" },
        { icon: "🔐", name: "Crypto Security", meta: "2 min · Basic level", bc: "+25 BC" },
        { icon: "🌐", name: "UNI2Chain and Web3", meta: "3 min · Medium level", bc: "+50 BC" },
        { icon: "🎓", name: "Full Module", meta: "5 lessons · Digital certificate", bc: "+50 BC + NFT", orange: true },
      ],
      visual_title: "MANDATORY DAILY VIDEO",
      visual_text_1: "Before your first match of the day, watch a short educational video on blockchain and crypto. It's mandatory — and you get paid for it.",
      visual_text_2: "At the end, a quick 1-2 question quiz. Getting it right gives more BC. Failing gives BC anyway. No penalty. Just learning.",
      badge: "🏆 NFT Certificate upon completing the module",
    },
    nft: {
      label: "💎 Cosmetics & NFTs",
      title_1: "Your CRYPTOBOOM, ", title_accent: "your identity.",
      sub: "Collectible skins, on-chain rarity, tradeable on OpenSea. 100 new NFTs every month.",
      cards: [
        { tier: "common", emoji: "💣", name: "CLASSIC BOOM", price: "200 BC", rarity: "COMMON" },
        { tier: "rare", emoji: "🔵", name: "CYBER BOOM", price: "500 BC", rarity: "RARE" },
        { tier: "epic", emoji: "⚡", name: "PLASMA BOOM", price: "1,000 BC", rarity: "EPIC" },
        { tier: "legendary", emoji: "👑", name: "SATOSHI BOOM", price: "10,000 BC", rarity: "LEGENDARY" },
      ],
      footnote: "NFTs are ERC-721 on UNI2Chain. Tradeable on OpenSea. 5% royalty to creator. 100 new each month.",
    },
    viral: {
      l1: "You play. You earn real tokens.",
      l2: "You share. Your network pays you.",
      l3: "You learn crypto without realizing.",
      l4: "All in 5 minutes a day.",
      stats: [
        { num: "1.45x", label: "Viral K-Factor", color: "green" },
        { num: "35%", label: "Share Rate Target", color: "orange" },
        { num: "50%", label: "Retention Day 7", color: "blue" },
        { num: "7 days", label: "Doubling Time", color: "green" },
      ],
      cta: "💥 JOIN NOW · EARLY ADOPTER BONUS ACTIVE",
    },
    eco: {
      label: "🌐 UNI2Chain Ecosystem",
      title_1: "CRYPTOBOOM is ", title_accent: "the gateway.",
      sub: "The game connects with the entire UNI2 blockchain ecosystem. Every game user is a potential active member.",
      nodes: [
        { icon: "🎮", name: "CRYPTOBOOM", desc: "Viral casual game" },
        { icon: "🪙", name: "BOOM CREDITS", desc: "In-game currency" },
        { icon: "💎", name: "UNI2 TOKEN", desc: "Native blockchain" },
        { icon: "🏦", name: "STAKING", desc: "Earn APY + BC" },
        { icon: "🌐", name: "UNI2CHAIN", desc: "Full ecosystem" },
      ],
    },
    cta: {
      title_1: "READY TO", title_accent: "EXPLODE", title_2: "THE BLOCKCHAIN?",
      sub_1: "The early adopter bonus ", sub_strong: "expires soon",
      sub_2: ". 500 BC = 1 UNI2 Token. Only the first 30 days. Then rises to 1,000 BC. Don't wait.",
      btn_primary: "💣 PLAY NOW — IT'S FREE", btn_app: "📱 APP STORE", btn_play: "🤖 GOOGLE PLAY",
      note_1: "100% free · No mandatory purchases · ", note_link: "Read tokenomics →",
    },
    footer: {
      tagline: "The viral UNI2Chain game that turns casual players into blockchain citizens. Play. Earn. Explode.",
      col1: { title: "GAME", items: ["How to play", "Leaderboard", "Battle Pass", "Events"] },
      col2: { title: "EARN", items: ["BOOM Credits", "Convert Tokens", "Staking", "Referral"] },
      col3: { title: "UNI2", items: ["UNI2Chain", "Tokenomics", "CBC Business Club", "Whitepaper"] },
      copyright: "© 2026 CRYPTOBOOM · UNI2Chain Ecosystem · CBC Business Club",
    },
  },

  ru: {
    meta_title: "CRYPTOBOOM — Играй. Зарабатывай. Взрывай блокчейн.",
    ticker: [
      "🎮 CRYPTOBOOM УЖЕ ДОСТУПЕН",
      "💰 ЗАРАБАТЫВАЙ РЕАЛЬНЫЕ ТОКЕНЫ UNI2",
      "🚀 ЦЕЛЬ: 1,000,000 ПОЛЬЗОВАТЕЛЕЙ ЗА 90 ДНЕЙ",
      "🎓 ИЗУЧАЙ КРИПТУ ПОКА ИГРАЕШЬ",
      "🔥 500 BC = 1 ТОКЕН UNI2 (EARLY ADOPTER)",
      "🏆 ЕЖЕНЕДЕЛЬНЫЕ НАГРАДЫ ЛИДЕРБОРДА",
    ],
    fc_label: "💥 BOOM Credits заработано",
    fc_sub: "сообществом сегодня",
    ref_banner: {
      text_1: "🎁 Вас пригласил ",
      text_2: " — получи приветственный бонус ",
      bonus: "+100 BC",
      text_3: " при регистрации",
      close: "Закрыть",
    },
    nav: { play: "Играть", earn: "Зарабатывать", tasks: "Миссии", rank: "Рейтинг", academy: "Академия", nfts: "NFT", cta: "ИГРАТЬ" },
    hero: {
      eyebrow: "💣 ЭКОСИСТЕМА UNI2CHAIN · WEB3 GAMING",
      title_line1_a: "CRYPTO", title_line1_b: "BOOM",
      title_line2: "PLAY. EARN. ", title_line2_accent: "EXPLODE.",
      sub_1: "Самая ", sub_strong_1: "вирусная казуальная игра в блокчейне",
      sub_2: ". Летай, разрушай крипто-блоки, делись своим счётом и конвертируй ",
      sub_strong_2: "BOOM Credits в реальные токены UNI2",
      sub_3: ".",
      cta_primary: "💣 ИГРАТЬ БЕСПЛАТНО", cta_secondary: "НАГРАДЫ →",
    },
    stats: [
      { num: "1,000,000", label: "Цель по пользователям" },
      { num: "5,000,000 UNI2", label: "Токенов к распределению" },
      { num: "500 BC", label: "BC за 1 токен (early)" },
      { num: "50%", label: "Цель удержания D7" },
      { num: "90 дней", label: "До 1М пользователей" },
    ],
    howto: {
      label: "🎮 Механика игры",
      title_1: "Тапай, лети, разрушай.", title_accent: "Но с криптой.",
      sub: "Простая механика, которая захватывает за секунды. Глубина, удерживающая часами.",
      steps: [
        { icon: "✋", title: "Тап, чтобы лететь", desc: "Коснись экрана, чтобы CRYPTOBOOM поднялся. Отпусти — и он падает. Держи идеальный ритм." },
        { icon: "💥", title: "Свайп, чтобы уничтожить", desc: "Свайпни горизонтально для атаки. Крипто-блоки взрываются, давая дополнительные очки." },
        { icon: "🪙", title: "Собирай монеты", desc: "Летающие монеты на пути дают +5 BC каждая. Расчёт оптимальных маршрутов — секретный навык." },
        { icon: "📊", title: "Счёт = кредиты", desc: "Итоговый счёт конвертируется в BOOM Credits. Чем дальше — тем больше. Без лимита в день." },
        { icon: "📤", title: "Делись счётом", desc: "Каждый раз, когда делишься результатом, получаешь +50 BC. Автоскриншот включён." },
        { icon: "💎", title: "Обменивай на токены", desc: "Накапливай BOOM Credits и конвертируй в реальные UNI2 токены прямо в свой blockchain-кошелёк." },
      ],
    },
    earn: {
      label: "💰 Система вознаграждений",
      title_1: "Каждое действие стоит ", title_accent: "реальных денег.",
      sub: "Это не пустые очки. BOOM Credits конвертируются в реальные токены UNI2 в блокчейне.",
      items: [
        { icon: "🎮", name: "Сыграть партию", detail: "На основе счёта · без дневного лимита", reward: "+10–100 BC" },
        { icon: "📤", name: "Поделиться результатом", detail: "Автоскриншот · до 3 раз/день", reward: "+50 BC" },
        { icon: "🎬", name: "Посмотреть видео", detail: "YouTube ежедневно · 2-3 минуты", reward: "+25 BC" },
        { icon: "🧠", name: "Квиз после видео", detail: "1-2 вопроса · без штрафа за ошибку", reward: "+5–15 BC" },
        { icon: "👥", name: "Приглашай друзей", detail: "+100 BC за 3 загрузки · без лимита", reward: "+100 BC" },
        { icon: "📚", name: "Пройти модуль", detail: "Web3 Академия · цифровой сертификат", reward: "+50 BC" },
        { icon: "🏆", name: "Топ 10 лидерборда", detail: "Еженедельный рейтинг · Золото/Серебро/Бронза", reward: "+250–1000 BC", orange: true },
      ],
      conv_title: "💱 КОНВЕРТАЦИЯ BC → UNI2",
      conv_rows: [
        { label: "Early Adopter (30 дней)", val: "500 BC = 1 UNI2" },
        { label: "Стандартный курс", val: "1000 BC = 1 UNI2" },
        { label: "Поздний курс (6+ мес.)", val: "1500 BC = 1 UNI2" },
        { label: "Стейкинг 30 дней", val: "+20% BC бонус" },
        { label: "Стейкинг 90 дней", val: "+35% BC бонус" },
        { label: "Стейкинг 180 дней", val: "+50% BC бонус" },
      ],
      bonus_strong: "⚡ Early Adopter преимущество:",
      bonus_text: " Первые 30 дней курс ", bonus_highlight: "на 50% выгоднее",
      bonus_tail: ". Чем раньше начнёшь — тем больше токенов. В блокчейне время решает.",
    },
    tasks: {
      label: "📱 Социальные миссии",
      title_1: "Подпишись. Присоединяйся. ", title_accent: "Получай.",
      sub: "Выполнение социальных задач приносит реальные кредиты. Один раз — и навсегда.",
      cards: [
        { col: "tg", icon: "✈️", name: "Вступи в Telegram", desc: "Официальный канал UNI2Chain. Новости, алерты, альфа и сообщество 24/7.", badge: "+100 BC", freq: "Один раз · навсегда" },
        { col: "ig", icon: "📸", name: "Подпишись в Instagram", desc: "Эксклюзивный контент, советы, NFT-дропы и анонсы событий.", badge: "+75 BC", freq: "Один раз · навсегда" },
        { col: "yt", icon: "▶️", name: "Подпишись на YouTube", desc: "Крипто-туториалы, обзоры геймплея и бесплатные Web3-курсы.", badge: "+60 BC", freq: "Один раз · навсегда" },
        { col: "tw", icon: "🐦", name: "Подпишись на X / Twitter", desc: "Обновления в реальном времени, опросы и ретвиты за дополнительные BC.", badge: "+50 BC", freq: "Один раз · навсегда" },
        { col: "share", icon: "🔗", name: "Поделись результатом", desc: "Каждая партия генерирует эпичный скриншот. Поделись и брось вызов друзьям.", badge: "+50 BC", freq: "До 3x в день · без лимита" },
        { col: "ref", icon: "🤝", name: "Приглашение друзей", desc: "Твой уникальный код приводит друзей. Они получают бонус, ты — пока они играют.", badge: "+100 BC / 3 друга", freq: "Без лимита · и 10 BC с каждой партии сети", orange: true },
      ],
    },
    gami: {
      label: "🎯 Глубокая геймификация",
      title_1: "Игра, которую ", title_accent: "не бросишь.",
      sub: "Каждая механика создаёт привычку, конкуренцию и желание возвращаться каждый день.",
      cards: [
        { icon: "🔥", title: "Ежедневные стрики", desc: "Играй подряд и умножай заработок. Потеря стрика — больно, и это возвращает тебя.", highlight: "+10% BC ЗА ПОДРЯДНЫЙ ДЕНЬ" },
        { icon: "🏆", title: "Глобальный лидерборд", desc: "Топ-100 виден. Обновляется каждый час. Лидеры получают реальные BC еженедельно.", highlight: "ДО 1,000 BC В НЕДЕЛЮ" },
        { icon: "⚡", title: "Battle Pass", desc: "50 уровней наград за 30 дней. Бесплатный даёт базу. Премиум — эксклюзивные косметики и редкие NFT.", highlight: "$4.99 ИЛИ 1,000 BC" },
        { icon: "🎪", title: "Лимитированные события", desc: "Каждые 2 недели 48-часовое событие. Уникальные темы, 2x BC множитель.", highlight: "КАЖДЫЕ 2 НЕДЕЛИ · 48Ч" },
        { icon: "⚔️", title: "PvP вызовы", desc: "Брось вызов друзьям своим кодом. Обойди их счёт. Если победят — оба получают бонус.", highlight: "+30 BC ЗА ПОБЕДУ" },
        { icon: "🎯", title: "Ежедневный челлендж", desc: "Специальная цель каждый день. «Уничтожь 10 BTC блоков» или «пройди 500м».", highlight: "+50 BC + СОХРАНЯЕТ СТРИК" },
      ],
    },
    streaks: {
      label: "🔥 Система стриков",
      title_1: "Каждый день важен. ", title_accent: "Не прерывай стрик.",
      steps: [
        { day: "ДЕНЬ 1", reward: "🎮", text: "Начни свой стрик. Первые кредиты твои." },
        { day: "ДЕНЬ 3", reward: "⚡", text: "Бесплатный power-up разблокирован." },
        { day: "ДЕНЬ 7", reward: "🛍️", text: "20% скидка на весь магазин в течение 7 дней." },
        { day: "ДЕНЬ 30", reward: "🎰", text: "Вход на колесо наград. Токены, NFT, легендарные скины." },
      ],
    },
    leaderboard: {
      label: "🏆 Глобальный лидерборд",
      title_1: "Ты в ", title_accent: "ТОП 100?",
      sub: "Рейтинг обновляется каждый час. Лучшие получают реальные BOOM Credits каждую неделю.",
      h_rank: "#", h_player: "Игрок", h_score: "Счёт", h_bc: "BC заработано",
      rows: [
        { rank: "👑 1", cls: "rank-1", av: "CX", name: "CryptoXavier", country: "🇲🇽 Мексика", score: "284,750", bc: "28,475 BC" },
        { rank: "🥈 2", cls: "rank-2", av: "LB", name: "LunaBoom", country: "🇨🇴 Колумбия", score: "271,340", bc: "27,134 BC", avStyle: "linear-gradient(135deg,#f7931a,#ffcc00)" },
        { rank: "🥉 3", cls: "rank-3", av: "DM", name: "DefiMaster_ES", country: "🇪🇸 Испания", score: "258,910", bc: "25,891 BC", avStyle: "linear-gradient(135deg,#bb55ff,#5588ff)" },
        { rank: "4", cls: "rank-other", av: "BK", name: "BlockKing_AR", country: "🇦🇷 Аргентина", score: "241,200", bc: "24,120 BC", avStyle: "linear-gradient(135deg,#00aaff,#00ffcc)" },
        { rank: "5", cls: "rank-other", av: "SH", name: "SatoshiHunter", country: "🇵🇪 Перу", score: "229,880", bc: "22,988 BC", avStyle: "linear-gradient(135deg,#ff5588,#ffaa00)" },
        { rank: "6", cls: "rank-other", av: "WM", name: "Web3Maniac_UAE", country: "🇦🇪 Дубай", score: "218,500", bc: "21,850 BC", avStyle: "linear-gradient(135deg,#33ff88,#00aaff)" },
        { rank: "7", cls: "rank-other", av: "NB", name: "NakamotoBomb", country: "🇧🇷 Бразилия", score: "204,770", bc: "20,477 BC", avStyle: "linear-gradient(135deg,#ffdd00,#ff6600)" },
      ],
      cta_text: "Обновление каждый час · ", cta_link: "Играй и появись здесь →",
    },
    edu: {
      label: "🎓 Web3 Академия",
      title_1: "Изучай крипту. ", title_accent: "Получай за это.",
      sub: "Каждая сессия начинается с 2-3 минутного обучающего видео. Учись блокчейну, пока зарабатываешь.",
      modules: [
        { icon: "₿", name: "Что такое Bitcoin?", meta: "2 мин · Базовый", bc: "+25 BC" },
        { icon: "⛓️", name: "Блокчейн объяснён", meta: "3 мин · Базовый", bc: "+25 BC" },
        { icon: "🏦", name: "Введение в DeFi", meta: "3 мин · Средний", bc: "+25 BC" },
        { icon: "🔐", name: "Крипто-безопасность", meta: "2 мин · Базовый", bc: "+25 BC" },
        { icon: "🌐", name: "UNI2Chain и Web3", meta: "3 мин · Средний", bc: "+50 BC" },
        { icon: "🎓", name: "Полный модуль", meta: "5 уроков · Цифровой сертификат", bc: "+50 BC + NFT", orange: true },
      ],
      visual_title: "ОБЯЗАТЕЛЬНОЕ ЕЖЕДНЕВНОЕ ВИДЕО",
      visual_text_1: "Перед первой партией дня посмотри короткое видео о блокчейне и крипто. Это обязательно — и за это платят.",
      visual_text_2: "В конце — быстрый квиз из 1-2 вопросов. Правильный ответ — больше BC. Ошибка — BC всё равно. Без штрафов.",
      badge: "🏆 NFT сертификат за прохождение модуля",
    },
    nft: {
      label: "💎 Косметика и NFT",
      title_1: "Твой CRYPTOBOOM — ", title_accent: "твоя личность.",
      sub: "Коллекционные скины, ончейн-редкость, торгуются на OpenSea. 100 новых NFT каждый месяц.",
      cards: [
        { tier: "common", emoji: "💣", name: "CLASSIC BOOM", price: "200 BC", rarity: "COMMON" },
        { tier: "rare", emoji: "🔵", name: "CYBER BOOM", price: "500 BC", rarity: "RARE" },
        { tier: "epic", emoji: "⚡", name: "PLASMA BOOM", price: "1,000 BC", rarity: "EPIC" },
        { tier: "legendary", emoji: "👑", name: "SATOSHI BOOM", price: "10,000 BC", rarity: "LEGENDARY" },
      ],
      footnote: "NFT — это ERC-721 на UNI2Chain. Торгуются на OpenSea. 5% роялти создателю. 100 новых каждый месяц.",
    },
    viral: {
      l1: "Играешь. Зарабатываешь реальные токены.",
      l2: "Делишься. Твоя сеть платит тебе.",
      l3: "Учишь крипту незаметно.",
      l4: "Всё за 5 минут в день.",
      stats: [
        { num: "1.45x", label: "Viral K-Factor", color: "green" },
        { num: "35%", label: "Share Rate Target", color: "orange" },
        { num: "50%", label: "Retention Day 7", color: "blue" },
        { num: "7 дней", label: "Doubling Time", color: "green" },
      ],
      cta: "💥 ПРИСОЕДИНИТЬСЯ · EARLY ADOPTER БОНУС АКТИВЕН",
    },
    eco: {
      label: "🌐 Экосистема UNI2Chain",
      title_1: "CRYPTOBOOM — это ", title_accent: "точка входа.",
      sub: "Игра связана со всей blockchain-экосистемой UNI2. Каждый игрок — потенциальный активный участник.",
      nodes: [
        { icon: "🎮", name: "CRYPTOBOOM", desc: "Вирусная казуальная игра" },
        { icon: "🪙", name: "BOOM CREDITS", desc: "Внутриигровая валюта" },
        { icon: "💎", name: "UNI2 TOKEN", desc: "Нативный blockchain" },
        { icon: "🏦", name: "STAKING", desc: "Зарабатывай APY + BC" },
        { icon: "🌐", name: "UNI2CHAIN", desc: "Полная экосистема" },
      ],
    },
    cta: {
      title_1: "ГОТОВ", title_accent: "ВЗОРВАТЬ", title_2: "БЛОКЧЕЙН?",
      sub_1: "Early adopter бонус ", sub_strong: "скоро истекает",
      sub_2: ". 500 BC = 1 UNI2 токен. Только первые 30 дней. Потом вырастет до 1,000 BC. Не жди.",
      btn_primary: "💣 ИГРАТЬ — БЕСПЛАТНО", btn_app: "📱 APP STORE", btn_play: "🤖 GOOGLE PLAY",
      note_1: "100% бесплатно · Без обязательных покупок · ", note_link: "Читать токеномику →",
    },
    footer: {
      tagline: "Вирусная игра UNI2Chain, которая превращает казуальных игроков в граждан блокчейна. Play. Earn. Explode.",
      col1: { title: "ИГРА", items: ["Как играть", "Лидерборд", "Battle Pass", "События"] },
      col2: { title: "EARN", items: ["BOOM Credits", "Конвертация", "Стейкинг", "Рефералы"] },
      col3: { title: "UNI2", items: ["UNI2Chain", "Токеномика", "CBC Business Club", "Whitepaper"] },
      copyright: "© 2026 CRYPTOBOOM · UNI2Chain Ecosystem · CBC Business Club",
    },
  },

  "pt-br": {
    meta_title: "CRYPTOBOOM — Jogue. Ganhe. Exploda a Blockchain.",
    ticker: [
      "🎮 CRYPTOBOOM ESTÁ NO AR",
      "💰 GANHE TOKENS UNI2 REAIS",
      "🚀 META: 1.000.000 USUÁRIOS EM 90 DIAS",
      "🎓 APRENDA CRYPTO ENQUANTO JOGA",
      "🔥 500 BC = 1 TOKEN UNI2 (EARLY ADOPTER)",
      "🏆 RECOMPENSAS SEMANAIS NO RANKING",
    ],
    fc_label: "💥 BOOM Credits ganhos",
    fc_sub: "pela comunidade hoje",
    ref_banner: {
      text_1: "🎁 Você foi convidado por ",
      text_2: " — ganhe um bônus de ",
      bonus: "+100 BC",
      text_3: " ao se cadastrar",
      close: "Fechar",
    },
    nav: { play: "Jogar", earn: "Ganhar", tasks: "Missões", rank: "Ranking", academy: "Academia", nfts: "NFTs", cta: "JOGAR JÁ" },
    hero: {
      eyebrow: "💣 ECOSSISTEMA UNI2CHAIN · WEB3 GAMING",
      title_line1_a: "CRYPTO", title_line1_b: "BOOM",
      title_line2: "PLAY. EARN. ", title_line2_accent: "EXPLODE.",
      sub_1: "O jogo casual mais ", sub_strong_1: "viral do blockchain",
      sub_2: ". Voe, destrua blocos cripto, compartilhe seu score e converta seus ",
      sub_strong_2: "BOOM Credits em tokens UNI2 reais",
      sub_3: ".",
      cta_primary: "💣 JOGAR GRÁTIS", cta_secondary: "VER RECOMPENSAS →",
    },
    stats: [
      { num: "1.000.000", label: "Meta de usuários" },
      { num: "5.000.000 UNI2", label: "Tokens a distribuir" },
      { num: "500 BC", label: "BC por 1 Token (early)" },
      { num: "50%", label: "Retenção D7 alvo" },
      { num: "90 dias", label: "Para 1M de usuários" },
    ],
    howto: {
      label: "🎮 Mecânicas do Jogo",
      title_1: "Toque, voe, destrua.", title_accent: "Mas com crypto.",
      sub: "Mecânicas simples que fisgam em segundos. Profundidade que te segura por horas.",
      steps: [
        { icon: "✋", title: "Toque para Voar", desc: "Toque na tela para o CRYPTOBOOM subir. Solte e ele cai. Mantenha o ritmo perfeito para sobreviver." },
        { icon: "💥", title: "Deslize para Destruir", desc: "Deslize horizontalmente para lançar um ataque. Blocos cripto destrutíveis explodem dando pontos extras." },
        { icon: "🪙", title: "Colete Moedas", desc: "Moedas flutuantes no caminho somam +5 BC cada. Calcular rotas ótimas é a habilidade secreta." },
        { icon: "📊", title: "Score = Créditos", desc: "Seu score final vira BOOM Credits. Quanto mais longe você chega, mais ganha. Sem limite diário." },
        { icon: "📤", title: "Compartilhe seu Score", desc: "Cada vez que compartilha nas redes, ganha +50 BC extras. Screenshot automático incluso." },
        { icon: "💎", title: "Troque por Tokens", desc: "Acumule BOOM Credits e converta em UNI2 Tokens reais direto na sua wallet blockchain." },
      ],
    },
    earn: {
      label: "💰 Sistema de Recompensas",
      title_1: "Cada ação vale ", title_accent: "dinheiro real.",
      sub: "Não são pontos vazios. BOOM Credits são convertíveis em tokens UNI2 reais no blockchain.",
      items: [
        { icon: "🎮", name: "Jogar uma partida", detail: "Com base no score final · sem limite diário", reward: "+10–100 BC" },
        { icon: "📤", name: "Compartilhar resultado", detail: "Screenshot automático · até 3 vezes/dia", reward: "+50 BC" },
        { icon: "🎬", name: "Ver vídeo educativo", detail: "YouTube diário · 2-3 minutos", reward: "+25 BC" },
        { icon: "🧠", name: "Quiz pós-vídeo", detail: "1-2 perguntas · sem penalidade se errar", reward: "+5–15 BC" },
        { icon: "👥", name: "Indicar amigos", detail: "+100 BC a cada 3 downloads · sem limite", reward: "+100 BC" },
        { icon: "📚", name: "Completar módulo", detail: "Academia Web3 · certificado digital incluso", reward: "+50 BC" },
        { icon: "🏆", name: "Top 10 leaderboard", detail: "Ranking semanal · Ouro/Prata/Bronze", reward: "+250–1000 BC", orange: true },
      ],
      conv_title: "💱 CONVERSÃO BC → UNI2",
      conv_rows: [
        { label: "Taxa Early Adopter (30 dias)", val: "500 BC = 1 UNI2" },
        { label: "Taxa Padrão", val: "1000 BC = 1 UNI2" },
        { label: "Taxa Tardia (6+ meses)", val: "1500 BC = 1 UNI2" },
        { label: "Staking 30 dias", val: "+20% BC bônus" },
        { label: "Staking 90 dias", val: "+35% BC bônus" },
        { label: "Staking 180 dias", val: "+50% BC bônus" },
      ],
      bonus_strong: "⚡ Vantagem Early Adopter:",
      bonus_text: " Nos primeiros 30 dias a taxa é ", bonus_highlight: "50% melhor",
      bonus_tail: ". Quanto antes começar, mais tokens pelo mesmo esforço. Tempo importa no blockchain.",
    },
    tasks: {
      label: "📱 Missões Sociais",
      title_1: "Siga. Junte-se. ", title_accent: "Receba.",
      sub: "Completar tarefas sociais dá créditos reais. Uma vez, para sempre. O ecossistema cresce, você ganha.",
      cards: [
        { col: "tg", icon: "✈️", name: "Entre no Telegram", desc: "Canal oficial da UNI2Chain. Notícias, alertas, alpha exclusivo e comunidade 24/7.", badge: "+100 BC", freq: "Uma vez · permanente" },
        { col: "ig", icon: "📸", name: "Siga no Instagram", desc: "Conteúdo exclusivo, dicas do jogo, drops de NFTs e anúncios de eventos.", badge: "+75 BC", freq: "Uma vez · permanente" },
        { col: "yt", icon: "▶️", name: "Inscreva-se no YouTube", desc: "Tutoriais crypto, gameplays e cursos Web3 gratuitos em vídeo.", badge: "+60 BC", freq: "Uma vez · permanente" },
        { col: "tw", icon: "🐦", name: "Siga no X / Twitter", desc: "Updates em tempo real, polls da comunidade e retweets que dão BC extras.", badge: "+50 BC", freq: "Uma vez · permanente" },
        { col: "share", icon: "🔗", name: "Compartilhar resultado", desc: "Cada partida gera um screenshot épico. Compartilhe e desafie seus amigos.", badge: "+50 BC", freq: "Até 3x por dia · ilimitado" },
        { col: "ref", icon: "🤝", name: "Indicação de amigos", desc: "Seu código único traz amigos. Eles ganham bônus ao entrar, você ganha enquanto eles jogam.", badge: "+100 BC / 3 amigos", freq: "Ilimitado · também ganha 10 BC por partida da sua rede", orange: true },
      ],
    },
    gami: {
      label: "🎯 Gamificação Profunda",
      title_1: "O jogo que você ", title_accent: "não larga.",
      sub: "Cada mecânica é projetada para criar hábito, competição e vontade de voltar todo dia.",
      cards: [
        { icon: "🔥", title: "Daily Streaks", desc: "Jogue dias consecutivos e multiplique seus ganhos. Perder o streak dói — e isso te traz de volta.", highlight: "+10% BC POR DIA CONSECUTIVO" },
        { icon: "🏆", title: "Leaderboard Global", desc: "Top 100 visível. Atualiza a cada hora. Líderes ganham BC reais toda semana. Você está no topo?", highlight: "ATÉ 1.000 BC SEMANAIS" },
        { icon: "⚡", title: "Battle Pass", desc: "50 níveis de recompensa em 30 dias. Grátis dá acesso básico. Premium libera cosméticos exclusivos e NFTs raros.", highlight: "$4.99 OU 1.000 BC" },
        { icon: "🎪", title: "Eventos Limitados", desc: "A cada 2 semanas um evento especial de 48 horas. Temáticas únicas, cosméticos exclusivos e 2x BC multiplicado.", highlight: "CADA 2 SEMANAS · 48H" },
        { icon: "⚔️", title: "Desafios PvP", desc: "Desafie amigos com seu código pessoal. Supere o score deles. Se ganharem, ambos recebem recompensa extra.", highlight: "+30 BC POR VITÓRIA" },
        { icon: "🎯", title: "Daily Challenge", desc: "Um objetivo especial a cada dia. \"Destrua 10 blocos BTC\" ou \"alcance 500m\". Completar alimenta seu streak.", highlight: "+50 BC + MANTÉM STREAK" },
      ],
    },
    streaks: {
      label: "🔥 Sistema de Streaks",
      title_1: "Cada dia importa. ", title_accent: "Não quebre o streak.",
      steps: [
        { day: "DIA 1", reward: "🎮", text: "Inicie seu streak. Os primeiros créditos são seus." },
        { day: "DIA 3", reward: "⚡", text: "Power-up grátis desbloqueado. Boost especial para sua próxima partida." },
        { day: "DIA 7", reward: "🛍️", text: "20% de desconto em toda a loja por 7 dias completos." },
        { day: "DIA 30", reward: "🎰", text: "Entrada na Roleta de Recompensas. Tokens, NFTs, skins lendárias." },
      ],
    },
    leaderboard: {
      label: "🏆 Leaderboard Global",
      title_1: "Você está no ", title_accent: "TOP 100?",
      sub: "O ranking atualiza a cada hora. Os melhores cada semana recebem BOOM Credits reais.",
      h_rank: "#", h_player: "Jogador", h_score: "Score", h_bc: "BC Ganhos",
      rows: [
        { rank: "👑 1", cls: "rank-1", av: "CX", name: "CryptoXavier", country: "🇲🇽 México", score: "284.750", bc: "28.475 BC" },
        { rank: "🥈 2", cls: "rank-2", av: "LB", name: "LunaBoom", country: "🇨🇴 Colômbia", score: "271.340", bc: "27.134 BC", avStyle: "linear-gradient(135deg,#f7931a,#ffcc00)" },
        { rank: "🥉 3", cls: "rank-3", av: "DM", name: "DefiMaster_ES", country: "🇪🇸 Espanha", score: "258.910", bc: "25.891 BC", avStyle: "linear-gradient(135deg,#bb55ff,#5588ff)" },
        { rank: "4", cls: "rank-other", av: "BK", name: "BlockKing_AR", country: "🇦🇷 Argentina", score: "241.200", bc: "24.120 BC", avStyle: "linear-gradient(135deg,#00aaff,#00ffcc)" },
        { rank: "5", cls: "rank-other", av: "SH", name: "SatoshiHunter", country: "🇵🇪 Peru", score: "229.880", bc: "22.988 BC", avStyle: "linear-gradient(135deg,#ff5588,#ffaa00)" },
        { rank: "6", cls: "rank-other", av: "WM", name: "Web3Maniac_UAE", country: "🇦🇪 Dubai", score: "218.500", bc: "21.850 BC", avStyle: "linear-gradient(135deg,#33ff88,#00aaff)" },
        { rank: "7", cls: "rank-other", av: "NB", name: "NakamotoBomb", country: "🇧🇷 Brasil", score: "204.770", bc: "20.477 BC", avStyle: "linear-gradient(135deg,#ffdd00,#ff6600)" },
      ],
      cta_text: "Atualização a cada hora · ", cta_link: "Jogue agora e apareça aqui →",
    },
    edu: {
      label: "🎓 Academia Web3",
      title_1: "Aprenda crypto. ", title_accent: "Seja pago por isso.",
      sub: "Cada sessão começa com um vídeo educativo de 2-3 minutos. Aprenda blockchain enquanto ganha tokens.",
      modules: [
        { icon: "₿", name: "O que é Bitcoin?", meta: "2 min · Nível básico", bc: "+25 BC" },
        { icon: "⛓️", name: "Blockchain explicado", meta: "3 min · Nível básico", bc: "+25 BC" },
        { icon: "🏦", name: "Introdução a DeFi", meta: "3 min · Nível médio", bc: "+25 BC" },
        { icon: "🔐", name: "Segurança em Crypto", meta: "2 min · Nível básico", bc: "+25 BC" },
        { icon: "🌐", name: "UNI2Chain e Web3", meta: "3 min · Nível médio", bc: "+50 BC" },
        { icon: "🎓", name: "Módulo Completo", meta: "5 lições · Certificado digital", bc: "+50 BC + NFT", orange: true },
      ],
      visual_title: "VÍDEO DIÁRIO OBRIGATÓRIO",
      visual_text_1: "Antes da sua primeira partida do dia, veja um vídeo educativo curto sobre blockchain e crypto. É obrigatório — e você é pago por isso.",
      visual_text_2: "Ao final, um quiz rápido de 1-2 perguntas. Acertar dá mais BC. Errar dá BC igual. Sem penalidade. Só aprendizado.",
      badge: "🏆 Certificado NFT ao completar o módulo",
    },
    nft: {
      label: "💎 Cosméticos & NFTs",
      title_1: "Seu CRYPTOBOOM, ", title_accent: "sua identidade.",
      sub: "Skins colecionáveis, raridade on-chain, negociáveis na OpenSea. 100 NFTs novos por mês.",
      cards: [
        { tier: "common", emoji: "💣", name: "CLASSIC BOOM", price: "200 BC", rarity: "COMMON" },
        { tier: "rare", emoji: "🔵", name: "CYBER BOOM", price: "500 BC", rarity: "RARE" },
        { tier: "epic", emoji: "⚡", name: "PLASMA BOOM", price: "1.000 BC", rarity: "EPIC" },
        { tier: "legendary", emoji: "👑", name: "SATOSHI BOOM", price: "10.000 BC", rarity: "LEGENDARY" },
      ],
      footnote: "Os NFTs são ERC-721 na UNI2Chain. Negociáveis na OpenSea. 5% de royalty ao criador. 100 novos por mês.",
    },
    viral: {
      l1: "Você joga. Ganha tokens reais.",
      l2: "Compartilha. Sua rede te paga.",
      l3: "Aprende crypto sem perceber.",
      l4: "Tudo em 5 minutos por dia.",
      stats: [
        { num: "1.45x", label: "Viral K-Factor", color: "green" },
        { num: "35%", label: "Share Rate Target", color: "orange" },
        { num: "50%", label: "Retention Day 7", color: "blue" },
        { num: "7 dias", label: "Doubling Time", color: "green" },
      ],
      cta: "💥 ENTRE AGORA · BÔNUS EARLY ADOPTER ATIVO",
    },
    eco: {
      label: "🌐 Ecossistema UNI2Chain",
      title_1: "CRYPTOBOOM é ", title_accent: "a porta de entrada.",
      sub: "O jogo conecta com todo o ecossistema blockchain da UNI2. Cada usuário do jogo é um potencial membro ativo.",
      nodes: [
        { icon: "🎮", name: "CRYPTOBOOM", desc: "Jogo casual viral" },
        { icon: "🪙", name: "BOOM CREDITS", desc: "Moeda in-game" },
        { icon: "💎", name: "UNI2 TOKEN", desc: "Blockchain nativa" },
        { icon: "🏦", name: "STAKING", desc: "Ganhe APY + BC" },
        { icon: "🌐", name: "UNI2CHAIN", desc: "Ecossistema completo" },
      ],
    },
    cta: {
      title_1: "PRONTO PARA", title_accent: "EXPLODIR", title_2: "A BLOCKCHAIN?",
      sub_1: "O bônus early adopter ", sub_strong: "expira em breve",
      sub_2: ". 500 BC = 1 UNI2 Token. Apenas os primeiros 30 dias. Depois sobe para 1.000 BC. Não espere.",
      btn_primary: "💣 JOGAR AGORA — É GRÁTIS", btn_app: "📱 APP STORE", btn_play: "🤖 GOOGLE PLAY",
      note_1: "100% gratuito · Sem compras obrigatórias · ", note_link: "Ler tokenomia →",
    },
    footer: {
      tagline: "O jogo viral da UNI2Chain que converte jogadores casuais em cidadãos do blockchain. Play. Earn. Explode.",
      col1: { title: "JOGO", items: ["Como jogar", "Leaderboard", "Battle Pass", "Eventos"] },
      col2: { title: "EARN", items: ["BOOM Credits", "Converter Tokens", "Staking", "Indicação"] },
      col3: { title: "UNI2", items: ["UNI2Chain", "Tokenomia", "CBC Business Club", "Whitepaper"] },
      copyright: "© 2026 CRYPTOBOOM · UNI2Chain Ecosystem · CBC Business Club",
    },
  },
};
